<template>
	<div class="tep_con_wrap">
		<div class="tep_con">
			<div class="bg_con fixedclear" id="tep_ht">
				<div class="aside_left fl_left">
					<ul class="tep_list">
						<li  v-for="(item,key) in creyName"  :class="{active:active[key]}"  class="" @click="Template($event,key)">
							<div class="icon_img">
								<div class="icon_img_src">
									<img :src="item.img.src1" alt="">
								</div>
								<div v-if="item.name.length>4"  style="font-size:22px" class="cg_cl">
									<span>{{item.name}}</span><span>{{item.minutes}}'</span>
								</div>
								<div v-else class="cg_cl">
									<span>{{item.name}}</span><span>{{item.minutes}}'</span>
								</div>
								
							</div>
						</li>
					</ul>
				</div>
				<div class="aside_right fl_right"  v-if="tmplt==1">
					<div class="teplate_tit" >
						<div class="conlist fixedclear" v-for="(item,key) in inforShow">
							<div class="list_tit fixedclear">
								<div class="tits fl_left">{{item.bg_title}}</div>
								<div class="music fl_left" v-if="item.music" v-for="(itemMusic,keyMusic) in item.music" @click="plays($event,key,keyMusic)"> 
									<div class="music_icon">
										<audio :src="itemMusic.src" class="play"></audio>
									</div>
								</div>
								<div class="bkxq_wrapper fl_right" @click="xq_show($event,key)"  v-if="toId2[key]">
									<span>备课详情</span>
								</div>
								<div class="xq_box">
									<div class="xq_del" @click="xq_hide($event)"></div>
									<div class="xq_list" v-for="(itemBkxq,ky) in inforShow1">
										<div class="fixedclear">
											<div class="xqTit fl_left">{{itemBkxq.title}}</div>
											<div class="music musics fl_left" v-for="(itemMusicq,keysMusic) in itemBkxq.videoSrc" @click="player($event,key,ky,keysMusic)"> 
												<div class="music_icon">
													<audio :src="itemMusicq.src" class="play"></audio>
												</div>
											</div>
										</div>
										<div class="xqCon" v-for="BkxqTxt in itemBkxq.list" >
											<div v-if="BkxqTxt.content" v-html="BkxqTxt.content">{{BkxqTxt.content}}</div>
										</div>
										<div class="xqImg_wrap" v-for="BkxqImg in itemBkxq.two_picture">
											<div class="xqImg" v-for="Bkxqurl in BkxqImg.imgBase64">
												<img :src="Bkxqurl" alt="">
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="list_wb">
								<div class="wb_con">
									<div class="wb_tit" v-html="item.bg_text">{{item.bg_text}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="aside_right1 fl_right" v-if="tmplt==2">
					<div class="miuse_wrap">
						<div class="miuse_tit fl_left dan_btn" @click="play($event,index)" v-if="musicList" :class="{'dbtn0':index==0,'dbtn1':index==1,'dbtn2':index==2,'dbtn3':index==3,'dbtn4':index==4,'dbtn5':index==5,'dbtn6':index==6,'dbtn7':index==7,'dbtn8':index==8,'dbtn9':index==9}" v-for="(item,index) in musicList">
							<span>{{item.name}}</span>
							<em>{{item.src}}</em>
							<div class="dele_music" @click="dele_mus($event,index)"></div>
						</div>
					</div>
					<div class="inf_wrap">
						<div class="inf_add">
						</div>
						<div class="conlist"  v-for="(item,key) in inforShow" @click="xgContent($event,key)">
							<div class="list_tit fixedclear">
								<div class="tits fl_left">{{item.bg_title}}</div>
								<div class="bkxq_wrapper fl_right" @click="xq_show($event,key)" v-if="toId2[key]">
									<span>备课详情</span>
								</div>
								<div class="xq_box">
									<div class="xq_del" @click="xq_hide($event)"></div>
									<div class="xq_list" v-for="(itemBkxq,ky) in inforShow1">
										<div class="fixedclear">
											<div class="xqTit fl_left">{{itemBkxq.title}}</div>
											<div class="music fl_left" v-for="(itemMusicq,keysMusic) in itemBkxq.videoSrc" @click="plays($event,key,ky,keysMusic)"> 
												<div class="music_icon">
													<audio :src="itemMusicq.src" class="play"></audio>
												</div>
											</div>
										</div>
										<div class="xqCon" v-for="BkxqTxt in itemBkxq.list" >
											<div v-if="BkxqTxt.content" v-html="BkxqTxt.content">{{BkxqTxt.content}}</div>
										</div>
									</div>
								</div>
							</div>
							<div class="list_wb">
								<div class="wb_con">
									<div class="wb_tit" v-html="item.bg_text">{{item.bg_text}}</div>
								</div>
							</div>
							<div class="imgsrc" v-for="(items,keys) in item.one_img">
								<img :src="vals" alt="" v-for='(vals,indexs) in items.imgUrl'>
							</div>
							<div class="videoSrc">
								<audio src="itemVideo.fileLs" v-for="(itemVideo,keyVideo) in item.one_video"></audio>
							</div>
						</div>
					</div>
					<div class="video_wrap">
						<div class="video_b fl_left" @click="players" v-model="psop"></div>
						<div class="video_con fl_left">
							<div class="miuse_top">
								<div class="mus_TB">
									<div class="mus_tit fl_left">音乐名称</div>
									<div class="mus_time fl_right">
										<span class="starttime">00:00</span> /
										<span class="endtime">00:00</span>
									</div>
									<div class="audis_wrap">
										<audio :src="musicPlay" class="audis" id="audis"></audio>
									</div>
									<div class="fixclear"></div>
								</div>
								<div class="mus_bar">
									<b class="progress-bar" :style="{width:proBar+'%'}"></b>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="aside_right2 fl_right"  v-if="tmplt==3">
					<div class="teplate_tit" >
						<div class="conlist fixedclear" v-for="(item,key) in inforShow">
							<div class="list_tit fixedclear">
								<div class="tits fl_left">{{item.bg_title}}</div>
								<div class="music fl_left" v-if="item.music" v-for="(itemMusic,keyMusic) in item.music" @click="plays($event,key,keyMusic)"> 
									<div class="music_icon">
										<audio :src="itemMusic.src" class="play"></audio>
									</div>
								</div>
								<div class="bkxq_wrapper fl_right" @click="xq_show($event,key)"  v-if="toId2[key]">
									<span>备课详情</span>
								</div>
								<div class="xq_box xq_box_wrap">
									<div class="xq_conTer">
										<div class="xq_del" @click="xq_hide($event)"></div>
										<div class="xq_list" v-for="(itemBkxq,ky) in inforShow1">
											<div class="fixedclear">
												<div class="xqTit fl_left">{{itemBkxq.title}}</div>
												<div class="music musics fl_left" v-for="(itemMusicq,keysMusic) in itemBkxq.videoSrc" @click="player($event,key,ky,keysMusic)"> 
													<div class="music_icon">
														<audio :src="itemMusicq.src" class="play"></audio>
													</div>
												</div>
											</div>
											<div class="xqCon" v-for="BkxqTxt in itemBkxq.list" >
												<div v-if="BkxqTxt.content" v-html="BkxqTxt.content">{{BkxqTxt.content}}</div>
											</div>
											<div class="xqImg_wrap" v-for="BkxqImg in itemBkxq.two_picture">
												<div class="xqImg" v-for="Bkxqurl in BkxqImg.imgBase64">
													<img :src="Bkxqurl" alt="">
												</div>
											</div>
										</div>
									</div>
									
								</div>
							</div>
							<div class="list_wb">
								<div class="wb_con">
									<div class="wb_tit" v-html="item.bg_text">{{item.bg_text}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default{
		data(){
			return{
				isActive:0,
				creyName:[],
				creyId:'',
				active: [true, false],
				who:'',
				inforShow:null,
				XQtoId:null,
				toId2:null,
				inforShow1:null,
				tmplt:0,
				proBar:0,
				psop:0,
				musicPlay:'',
				musicList:[]
			}
		},
		beforeDestroy(){
			var _this=this;
			$('.tep_list li:first-child').find('.cg_cl').css({'color':'#ffc957'}).parent().parent().siblings().find('.icon_img').children('.cg_cl').css({'color':'#fff'});
			$('.tep_list li:first-child').find('.icon_img').children('.icon_img_src').children('img').attr('src',_this.creyName[0].img.src2)
		},
		methods:{
			xq_hide(e){
				e.stopPropagation();
				$('.xq_box').hide()
			},
			xq_show(e,i){
				const _this=this;
				e.stopPropagation();
				$('.xq_box').show()
				_this.$axios.post('showmodtwo',{
					to_id:this.XQtoId[i]
				}).then(({data:{data}})=>{
					this.inforShow1=eval('('+data[0].json_data+')').detal
				})
			},
			play(e,key){
				e.stopPropagation()
				$('div.miuse_tit.fl_left.dan_btn').eq(key).addClass('danclick').siblings().removeClass('danclick')
				this.musicPlay=this.musicList[key].src
				$('.mus_tit').html($('.miuse_tit').eq(key).find('span').html())
				var time=document.getElementById("audis");
				time.load();
				time.oncanplay = function () {
					var minute=parseInt(time.duration/60);
					var second=Math.round(time.duration%60);
					if(minute<10){
						minute="0"+minute;
					}
					if(second<10){
						second="0"+second;
					}
					$('.mus_time').find('.endtime').html(minute+":"+second);
				}
				this.proBar=0;
			},
			players(){
				var time=document.querySelectorAll(".audis_wrap audio");
				var starttime=document.querySelector('.starttime');
				if(this.psop){
					$('.audis').get(0).pause();
					this.psop=0;
					$('.video_b').removeClass('pause');
				}else{
					$('.audis').get(0).play();
					$('.video_b').addClass('pause')	;
					this.psop=1;
					var times=0;
					$('.audis').on('timeupdate', function() {
						for(var i=0;i<time.length;i++){
							var minutes=parseInt(time[i].currentTime/60);
							var seconds=Math.round(time[i].currentTime%60);
							if(minutes<10){
								minutes="0"+minutes;
							}
							if(seconds<10){
								seconds="0"+seconds;
							}
					   		$('.starttime').text(minutes+":"+seconds);
					   		this.proBar=$('.progress-bar').width((time[i].currentTime/time[i].duration)*100+'%')
						}					
					});
				}	
			},
            plays(e,i,j){
				e.stopPropagation();
				if(this.music_state){
					$('.conlist').eq(i).find('.music').eq(j).find('.play').get(0).pause()
					this.music_state=0;
					$('.conlist').eq(i).find('.music').eq(j).find('.music_icon').removeClass('zcir');

				}else{
					$('.conlist').eq(i).find('.music').eq(j).find('.play').get(0).play().then((res)=>{
						this.music_state=1
						$('.conlist').eq(i).find('.music').eq(j).find('.music_icon').addClass('zcir')
					})
				}				
			},
			player(e,i,j,l){
				e.stopPropagation();
				if(this.music_state){
					$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).find('.play').get(0).pause()
					this.music_state=0;
					$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).find('.music_icon').removeClass('zcir');
				}else{
					$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).find('.play').get(0).play().then((res)=>{
						this.music_state=1
						$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).find('.music_icon').addClass('zcir')
					})
				}		
			},
			Template(e,i){
				e.stopPropagation();
		 		const _this=this;
		 		$('.xq_box').hide()
		 		$('.tep_list li').eq(i).find('.cg_cl').css({'color':'#ffc957'}).parent().parent().siblings().find('.icon_img').children('.cg_cl').css({'color':'#fff'});
		 		_this.creyName.forEach(function(item,index){
		 			$('.tep_list li').eq(i).find('.icon_img').children('.icon_img_src').children('img').attr('src',_this.creyName[i].img.src2)
		 			if(index!=i){
		 				$('.tep_list li').eq(index).find('.icon_img').children('.icon_img_src').children('img').attr('src',_this.creyName[index].img.src1)
		 			}
		 		})
		 		this.isActive=i;
		 		if(_this.creyName[i].template_id==3){
                	$('.aside_left').addClass('aside_left_change')
                	$('.tep_con').addClass('tep_con_changeBack')
                	$('.tep_list li').addClass('changeColor')
                }else{
                	$('.aside_left').removeClass('aside_left_change')
                	$('.tep_con').removeClass('tep_con_changeBack')
                	$('.tep_list li').removeClass('changeColor')
                }
		 		
		 		_this.$axios.post('modlist',{
		 			table_id:_this.$route.params.name
		 		}).then(({data:{data}})=>{
	        		_this.creyId=data[i].id;
	        		
		 		}).then(()=>{
		 			_this.$axios.post('showmodone',{
						tm_id:_this.creyId
					}).then(({data:{data}})=>{
						var arr=new Array()
						var obj=new Array()
						var arrs=new Array()
						this.xgCon=data;
						for(let i=0;i<data.length;i++){
							arr.push(eval('('+data[i].json_data+')'))
							obj.push(data[i].id)
							arrs.push(data[i].is_detail);
						}
						_this.inforShow=arr
						_this.XQtoId=obj
						_this.toId2=arrs
						var ids=new Array()
						var arr2=new Array()
						for(var j=0;j<obj.length;j++){
							_this.$axios.post('showmodtwo',{
								to_id:obj[j]
							}).then(({data:{data}})=>{
								data.onload=function(){
									var date1=eval('('+data[0].json_data+')')
									for(var i=0;i<date1.detal.length;i++){
										if(eval('('+date1.detal[i].two_adus+')'))
										arr2.push({
											"videoSrc":eval('('+date1.detal[i].two_adus+')'),
											"list":eval('('+date1.detal[i].list+')'),
											"title":eval('('+date1.detal[i].title+')'),
											"type":date1.detal[i].type
										})
									}
								}
								
							})
							ids.push(obj[j])
						}
						_this.inforShow1=arr2
					}).then(()=>{
						_this.tmplt=_this.creyName[i].template_id
						if(_this.tmplt==2){
				 			_this.$axios.post('modlist',{
								table_id:_this.creyName[i].table_id
							}).then(({data:{data}})=>{
								console.log(data)
								_this.musicList=[];
								for(var i=0;i<data.length;i++){
									if(data[i].id==_this.creyId){
										if(data[i].cery_right!=''){
											var arr=eval('('+data[i].cery_right+')')
											for(var j=0;j<arr.length;j++){
												_this.musicList.push(arr[j])
											}	
										}
									}
								}
							})
				 		}

		        		
					})
					
	        	})
		 	},
		 	showImg(){
		 		const _this=this;
		 		if(_this.creyName.length>0){
					for(var i=0;i<_this.creyName.length;i++){
						if(_this.creyName[i].minutes==0){
							$('.tep_list li').eq(i).find('.icon_img').find('.cg_cl').children('span:last-child').html('')
						}
					}
		 			if(_this.creyName[0].template_id==3){
	                	$('.aside_left').addClass('aside_left_change')
	                	$('.tep_con').addClass('tep_con_changeBack')
	                	$('.tep_list li').addClass('changeColor')
	                }else{
	                	$('.aside_left').removeClass('aside_left_change')
	                	$('.tep_con').removeClass('tep_con_changeBack')
	                	$('.tep_list li').removeClass('changeColor')
	                }
					$('.tep_list li').eq(0).find('.icon_img').find('.cg_cl').css({'color':'#ffc957'}).parent().parent().siblings().find('.icon_img').children('.cg_cl').css({'color':'#fff'});
			 		_this.creyName.forEach(function(item,index){
			 			$('.tep_list li').eq(0).find('.icon_img').children('.icon_img_src').children('img').attr('src',_this.creyName[0].img.src2)
			 			if(index != 0){
			 				$('.tep_list li').eq(index).find('.icon_img').children('.icon_img_src').children('img').attr('src',_this.creyName[index].img.src1)
			 			}
			 		})
				}
		 	}
		},
		created(){
			const _this=this;
			_this.$axios.post('modlist',{
				table_id:_this.$route.params.name
			}).then(({data:{data}})=>{
				for(var i=0;i<data.length;i++){
					_this.creyName.push({
						id:data[i].id,
    					img:eval('('+data[i].img+')'),
    					minutes:data[i].minutes,
    					name:data[i].name,
    					table_id:data[i].table_id,
    					template_id:data[i].template_id
					})
				}
				_this.creyId=data[0].id;
				_this.tmplt=_this.creyName[0].template_id
				_this.$axios.post('showmodone',{
					tm_id:data[0].id
				}).then(({data:{data}})=>{
					var arr=new Array()
					var obj=new Array()
					var arrs=new Array()
					this.xgCon=data;
					for(let i=0;i<data.length;i++){
						arr.push(eval('('+data[i].json_data+')'))
						obj.push(data[i].id)
						arrs.push(data[i].is_detail);
					}
					_this.inforShow=arr
					_this.XQtoId=obj
					_this.toId2=arrs
					var ids=new Array()
					var arr2=new Array()
					for(var j=0;j<obj.length;j++){
						_this.$axios.post('showmodtwo',{
							to_id:obj[j]
						}).then(({data:{data}})=>{
							data.onload=function(){
								var date1=eval('('+data[0].json_data+')')
								for(var i=0;i<date1.detal.length;i++){
									if(eval('('+date1.detal[i].two_adus+')'))
									arr2.push({
										"videoSrc":eval('('+date1.detal[i].two_adus+')'),
										"list":eval('('+date1.detal[i].list+')'),
										"title":eval('('+date1.detal[i].title+')'),
										"type":date1.detal[i].type
									})
								}
							}
						})
						ids.push(obj[j])
					}
					_this.inforShow1=arr2
				})
			}).then(()=>{
				_this.showImg()
			})
		},
		watch:{
		}
	};
</script>
<style scoped>
.miuse_tit{
		margin: 0 5px;
		overflow:hidden;
		line-height: 1.2;
		padding: 13px 10px;
		width: 142px;
		height: 43px;
		border-radius: 8px;
		box-sizing: border-box;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin-bottom: 20px;
		border:1px solid #ffbe70;
		color: #ffbe70;
		text-align: center;
		cursor: pointer;
		position: relative;
	}
	.miuse_wrap{
		width: 100%;
		box-sizing: border-box;
		padding-left: 32px;
		padding-top: 30px;
		height: 162px;
		background: #fff;
	}
	.tep_con_wrap{
		width: 1434px;
		height: 750px;
		background: #fff;
		margin: 0 auto;
		margin-top: 50px;
		display: flex;
		justify-content:center;
		align-items: center;
		font-size: 18px;
	}
	.tep_con{
		width: 1134px;
		height: 750px;
		background: #fff;
		background: url(../../../../static/imgs/start.png) 0 0 no-repeat;
		background-size: 1134px 637px;
	}
	.bg_con{
		margin-top: 43px;
	}
	.fixedclear:after{
		content: "";
		display: block;
		clear: both;
	}
	.aside_left{
		width: 225px;
		min-height: 680px;
		overflow-y: auto;
		background:#464985;
	}
	.tep_list{
		width: 225px;
		border-radius: 6px;
		color: #fff;
		text-align: center;
		overflow-y:auto;
		height: 637px;
	}
	.tep_list::-webkit-scrollbar{
		width:4px;
		height: 4px; 
	}
	.tep_list::-webkit-scrollbar-thumb{
		border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
	}
	.tep_list::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
	}
	.tep_list li{
		border-bottom: 1px solid #8789af;
		height: 96px;
		line-height: 96px;
	}
	.tep_list li.changeColor{
		border-bottom: 1px solid #fff;
	}
	.wb_con{
		width: 727px;
	}
	.aside_right{
		width: 909px;
		box-sizing: border-box;
		margin-top: 20px;
		min-height: 637px;
		overflow:auto;
		background: rgba(134, 141, 205, 0.95);
		padding:20px 0 0 32px;
		position: relative;
	}
	.aside_right2{
		width: 909px;
		box-sizing: border-box;
		margin-top: 20px;
		min-height: 637px;
		overflow:auto;
		background: rgba(230, 175, 169, 0.95);
		padding:20px 0 0 32px;
		position: relative;
	}
	.aside_right1{
		width: 909px;
		height: 680px;
		box-sizing: border-box;
		position: relative;
		background: rgba(134, 141, 205, 0.95);
	}
	.teplate_tit{
		width: 877px;
		height: 637px;
		overflow-y: auto;
	}
	.teplate_tit::-webkit-scrollbar{
		width:4px;
		height: 4px; 
	}
	.teplate_tit::-webkit-scrollbar-thumb{
		border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
	}
	.teplate_tit::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
	}
	.list_tit{
		color: #fff;
	}
	.list_wb{
		color: #fff;
	}
	.list_wb .wb_tit{
		font-size: 24px;
	}
	.wb_main{
		margin-left: 10px;
		height: 30px;
		line-height: 30px;
	}
	.tits{
		font-size: 32px;
	}
	.tits,.music,.bkxq_wrapper{
		height: 60px;
		line-height: 60px;
	}
	.bkxq_wrapper{
		margin-right: 20px;
	}
	.music{
		display: flex;
		justify-content: center;
		align-items: center;
		height: 60px;
	}
	.music_icon{
		background: url(../../../../static/imgs/icon_music.png) 0 center no-repeat;
		background-size: 100%;
		width: 28px;
		height: 28px;
		float: left;
		margin-left: 14px;
	}
	.musics{
		height: 32px;
	}
	.bkxq_wrapper{
		width: 80px;
		height: 30px;
		line-height: 30px;
		padding: 0 10px;
		text-align: center;
		color: #f095b9;
		border-radius: 4px;
		border:1px solid #f095b9;
		background: #fff;
		margin-top: 14px;
	}
	.xq_box{
		position: absolute;
		top: 0;
		left: 0;
		width: 909px;
		height: 680px;
		overflow:auto;
		background: url(../../../../static/imgs/xqbg.png) 0 0 no-repeat;
		background-size: 909px 680px;
		box-sizing: border-box;
		padding: 20px 25px;
		display: none;
		z-index: 99;
	}
	.xq_box::-webkit-scrollbar{
		width:4px;
		height: 4px; 
	}
	.xq_box::-webkit-scrollbar-thumb{
		border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
	}
	.xq_box::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
	}
	.xq_box_wrap{
		background:url(../../../../static/imgs/startback.png) 0 0 no-repeat;
		background-size: 909px 657px;
		height: 657px;
		box-sizing: content-box;
		padding: 0;
	}
	.xq_conTer{
		background:rgba(230, 175, 169, 0.95);
		box-sizing: border-box;
		padding: 20px 25px;
		height: 100%;
		overflow-y:auto;
	}
	.xq_conTer::-webkit-scrollbar{
		width:4px;
		height: 4px; 
	}
	.xq_conTer::-webkit-scrollbar-thumb{
		border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
	}
	.xq_conTer::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
	}
	.xq_del{
		position: absolute;
		top: 20px;
		right: 20px;
		width: 24px;
		height: 24px;
		background: url(../../../../static/imgs/xdel.png) 0 0 no-repeat;
	}
	.xq_list{
		margin-bottom: 30px;
	}
	.xqTit{
		font-size: 20px;
		height: 32px;
		line-height: 32px;
		margin-bottom: 10px;
	}
	.xqCon{
		/* line-height: 32px; */
		margin-bottom: 10px;
		/* padding-left: 20px;
		background: url(../../../static/imgs/tn_cir.png) 0 13px no-repeat;
		background-size: 8px; */
	}

	.zcir{
		animation: go 1.5s infinite; 
		animation-fill-mode:both;
	}
	@keyframes go{
		0%{
			transform: rotateZ(0);
		}
		100%{
			transform: rotateZ(360deg);
		}
	}
	.icon_img{
		display: flex;
		align-items: center;
		font-size: 28px;
	}
	.icon_img_src{
		display: flex;
		justify-content: center;
		align-items: center;
		width: 40px;
		height: 100%;
		padding-left: 10px;
		margin-right: 10px;
	}
	.icon_img_src>img{
		width: 40px;
		height: 40px; 
	}
	.fixedclear:after{
		content: "";
		display: block;
		clear: both;
	}
/*第二套模板*/
	.inf_wrap{
		background: url(../../../../static/imgs/start1.jpg) 0 0 no-repeat;
		width: 100%;
		height: 452px;
		background-size: 100% 452px;
		box-sizing: border-box;
		padding-left: 32px;
		padding-top: 20px;
		overflow:auto;
		color:#fff;
	}
	.inf_wrap::-webkit-scrollbar{
		width:4px;
		height: 4px; 
	}
	.inf_wrap::-webkit-scrollbar-thumb{
		border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
	}
	.inf_wrap::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
	}
.video_wrap{
		width: 100%;
		height:66px;
		background: #f7f7f7;
		box-sizing: border-box;
		padding-left: 59px;
	}
	.video_b{
		width: 35px;
		height: 66px;
		background: url(../../../../static/imgs/play.png) center center no-repeat;
		background-size: 100%;
	}
	.video_con{
		width: 736px;
		height: 66px;
		box-sizing: border-box;
		padding-left: 25px;
		background: url(../../../../static/imgs/bg_audio.png) right center no-repeat;
		background-size: 90px;
	}
	.mus_TB{
		width: 582px;
		height: 44px;
		line-height: 44px;
		color: #8c94cc;
		font-size: 14px;
	}
	.fixclear{
		width: 0;
		height: 0;
		overflow:hidden;
		clear: both;
	}
	.mus_bar{
		width: 582px;
		height: 14px;
		border-radius: 10px 10px 10px 10px;
		background: #d9d9d9;
		position: relative;
	}
	.pause{
		background: url(../../../../static/imgs/pause.png) center center no-repeat;
		background-size: 100%;
	}
	.progress-bar{
		position: absolute;
		top: 0;
		left: 0;
		display: inline-block;
		width: 0;
		height: 14px;
		border-radius:10px 10px 10px 10px;
		background: #8c94cc;
	}
	.dan_music{
		width: 100%;
		padding: 0.3rem 0.2rem 0.3rem 0;
		box-sizing: border-box;
		background-color: #fff;
		box-shadow: 1px 1px 2px 0px rgba(87, 90, 144, 0.25);
		position: relative;
		top:0;
		right: 0;
		overflow-x: hidden;
	}
	.dan_btn{
		background-color: rgba(255, 255, 255, 0.82);
		border-radius: 8px;
		border: solid 1px rgba(255, 188, 121, 0.82);
		text-align: center;
		box-sizing: border-box;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.aside_left_change{
		background: #b77372;
	}
	.tep_con_changeBack{
		background: url(../../../../static/imgs/startback.png) 0 0 no-repeat;
		background-size: 1134px 637px;
	}
</style>


// WEBPACK FOOTER //
// src/components/index/temlp/templet1.vue